
import { inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders, MS_PER_MINUTE } from '@skylab-shared/utils';

export interface InventoryStocktakingApprovalParams {
    id: number;
    type: 'approve' | 'disapprove'
}

export interface InventoryStocktakingApprovalCommandResult {}
export class InventoryStocktakingApprovalCommand extends Command<InventoryStocktakingApprovalParams, InventoryStocktakingApprovalCommandResult> {}

@CommandHandlerFor(InventoryStocktakingApprovalCommand)
@Injectable({ providedIn: 'root'})
export class InventoryStocktakingApprovalCommandHandler implements CommandHandler<InventoryStocktakingApprovalCommand, InventoryStocktakingApprovalParams, InventoryStocktakingApprovalCommandResult> {
    #approveUrl = TaggedUrl.join('inventory/stocktaking/:id/approve', [Tags.Api]);
    #disapproveUrl = TaggedUrl.join('inventory/stocktaking/:id/disapprove', [Tags.Api]);
    #http = inject(Http) as HttpService;

    public async handleAsync(command: InventoryStocktakingApprovalCommand): Promise<InventoryStocktakingApprovalCommandResult> {
        const url = command.params?.type === 'approve'
            ? this.#approveUrl
            : this.#disapproveUrl;
        const { data } = await this.#http.post<InventoryStocktakingApprovalCommandResult>(fillPlaceholders(url, { id: command.params?.id }), {}, { timeout: 3 * MS_PER_MINUTE });
        return data;
    }
}
